import React, { Fragment, useState } from 'react'

import styles from './HappyFoxWorkflows.module.css'

import Link from 'Design/components/Link'
import Label from 'Design/components/Label'
import FormControl from 'Design/components/FormControl'
import CopyInput from 'Src/b/components/CopyInput'
import parseErrorMessage from 'Utils/error-message-parser'
import toast from 'react-hot-toast'

import { useResetApiKeyMutation } from './happyfox-workflows.service'
import UnInstallHappyFoxWorkflows from './UnlnstallHappyFoxWorkflows'

const ManageHappyFoxWorkflows = (props) => {
  const { settings } = props

  const [apiKey, setApiKey] = useState(settings.api_key)
  const [resetApiKey, resetApiKeyResult] = useResetApiKeyMutation()

  const handleRegenerateKey = async () => {
    const promise = resetApiKey().unwrap()
    toast.promise(promise, {
      loading: 'Regenerating API key...',
      success: 'Regenerated API key successfully',
      error: parseErrorMessage('Failed to regenerate API key. Try again later')
    })
    promise
      .then((data) => {
        setApiKey(data.api_key)
      })
      .catch((err) => {
        console.error('Failed to regenerate HappyFox Workflows API key. Error:', err)
      })
  }

  const showCopyIcon = resetApiKeyResult.isSuccess || false

  return (
    <Fragment>
      <FormControl>
        <Label className={styles.RegenerateButtonContainer}>
          Your API Key{' '}
          {!showCopyIcon && (
            <Link
              className={styles.RegenerateButton}
              onClick={handleRegenerateKey}
              disabled={resetApiKeyResult.isLoading}
            >
              (Regenerate key)
            </Link>
          )}
        </Label>
        <CopyInput value={apiKey} canCopy={showCopyIcon} />
      </FormControl>
      {showCopyIcon && <p>Note: Please save this token safely, It will not be shown next time.</p>}
      <br />
      <UnInstallHappyFoxWorkflows />
    </Fragment>
  )
}

export default ManageHappyFoxWorkflows
